import React, { Fragment } from "react";
import { Link } from "react-router-dom";

const ApprovedMentorItem = ({ approvedmentor, user, profile }) => {
  return (
    <Fragment>
      <div className="user-section-alt">
        <div className="friends-user-container">
          <Link to={`/${approvedmentor.channelid}`}>
            <div className="friend-user-avi-container">
              <div className="avi-color-border red">
                <img
                  src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${approvedmentor.avatar}`}
                  className="friend-user-avi"
                />
              </div>
            </div>
          </Link>
          <div className="friend-user-info">
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="red name-font">
                    {approvedmentor.firstname} {approvedmentor.lastname}
                  </span>
                </li>
                <li className="user-online-item">{approvedmentor.jobtitle}</li>
                <li className="user-online-item">
                  {approvedmentor.location.city},{" "}
                  {approvedmentor.location.state}
                </li>
              </ul>
            </div>
          </div>
        </div>
        {user.user === profile.user && (
          <div className="friends-buttons-container">
            <div className="friend-button-container">
              <button className="friend-button background-red">
                <i className="fas fa-user-minus mx-5"></i>
                Remove
              </button>
            </div>
            <i className="fas fa-ellipsis-v fa-lg ellipsis-pos red"></i>
            <div className="modal">
              <ul className="modal-items">
                <li className="modal-item">
                  <i className="fas fa-flag mx-5 white"></i>
                  Report
                </li>
                <li className="modal-item">
                  <i className="fas fa-ban mx-5 white"></i>
                  Block
                </li>
              </ul>
            </div>
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default ApprovedMentorItem;
